// src/features/patients/prescriptions/utils/prescriptionSanitize.js
//
// Saneamento do HTML que veio do editor de prescrição.
//
// `full_content` é HTML de um contenteditable persistido no banco. Antes de
// reinjetar isso num documento (PDF, preview, janela de impressão) passamos por
// um whitelist de tags/atributos.
//
// A mecânica mora em `utils/sanitizeHtml.js`; aqui só ficam as regras
// específicas da prescrição — quais classes de bloco do editor sobrevivem.

import { sanitizeRichHtml, FORMATTING_TAGS } from "@/utils/sanitizeHtml";

// Só as classes que o editor usa para colorir os blocos sobrevivem.
const ALLOWED_CLASSES = new Set([
  "medication-line",
  "exam-line",
  "supplement-line",
]);

/**
 * @param {string} html conteúdo do editor
 * @returns {string} HTML sem atributos, só com tags de formatação e as
 *                   classes de bloco da prescrição
 */
export function sanitizePrescriptionHtml(html) {
  return sanitizeRichHtml(html, {
    allowedTags: FORMATTING_TAGS,
    allowedClasses: ALLOWED_CLASSES,
  });
}

// Reexportado por conveniência: o prescriptionDocument.js monta o receituário
// escapando campo a campo e importa os dois utilitários do mesmo lugar.
export { escapeHtml } from "@/utils/sanitizeHtml";
